import { Box, Chip, Link, Paper, Typography } from '@mui/material';
import moment from 'moment';
import { NavLinkComponent } from '../../Router';
import { DataListComponent, NoDataPaper } from '../../components/data/DataTable';
import { Bill } from '../../models/Types';
import { moneyFormat, periodNumToText } from '../../utils';

const styles = {
    mobileIconWrapper: {
        p: .66,
        display: 'flex',
        borderRadius: .5
    },
    mobileListItem: {
        display: 'flex',
        flexDirection: 'row!important',
        justifyContent: 'space-between',
        textDecoration: 'none',
        p: 2,
        gap: 2,
        alignItems: 'flex-start'
    }
}

export function buildBillListItem(x: Bill) {
    return <Paper component={NavLinkComponent} sx={styles.mobileListItem} elevation={2} route={[['page', 'bill'], ['id', x.Id]]}>
        <Box display="flex" flexDirection="column" minWidth={80} gap={.5}>
            <Link variant="h3" sx={{ textDecoration: 'none' }}>{moneyFormat(x.Amount)}</Link>
            <Typography variant="subtitle2">{moment(x.CreateDate).format('DD.MM.yy')}</Typography>
        </Box>
        <Box flex={1}>
            <Typography variant="h3" textAlign="left">{periodNumToText(x.PeriodNum)}</Typography>
        </Box>
        {x.Amount ? <Chip size="small" color={x.PaymentId ? 'success' : 'error'} label={(x.PaymentId ? 'О' : 'Не о') + 'плачено'} /> : null}
    </Paper>;
}

export default class BillList extends DataListComponent<Bill> {
    renderNoData() {
        return <NoDataPaper title="Начисления отсутствуют" content={['В этом разделе будут отображаться начисления на оплату, выставляемые УК']} />;
    }

    buildItemPaper(x: Bill, i: number) {
        return buildBillListItem(x);
    }
}